import { render, staticRenderFns } from "./QCard.vue?vue&type=template&id=01c239ac&scoped=true&"
import script from "./QCard.vue?vue&type=script&lang=ts&"
export * from "./QCard.vue?vue&type=script&lang=ts&"
import style0 from "./QCard.vue?vue&type=style&index=0&id=01c239ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c239ac",
  null
  
)

export default component.exports